import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IQuestionsListModalsState {
  isCopyQueryOpen: boolean;
  isBulkSharingOpen: boolean;
  isBulkChangeAuthorOpen: boolean;
  queryFromListView: { id: number; description: string } | null;
}

export const initialState: IQuestionsListModalsState = {
  isCopyQueryOpen: false,
  isBulkSharingOpen: false,
  isBulkChangeAuthorOpen: false,
  queryFromListView: null,
};

export const questionsListModalsReducer = {
  resetState: (state: IQuestionsListModalsState) => {
    Object.assign(state, initialState);
  },

  openCopyQuery: (
    state: IQuestionsListModalsState,
    action: PayloadAction<{ id: number; description: string }>
  ) => {
    state.isCopyQueryOpen = true;
    state.queryFromListView = action.payload;
  },

  closeCopyQuery: (state: IQuestionsListModalsState) => {
    state.isCopyQueryOpen = false;
    state.queryFromListView = null;
  },

  openBulkSharing: (state: IQuestionsListModalsState) => {
    state.isBulkSharingOpen = true;
  },

  closeBulkSharing: (state: IQuestionsListModalsState) => {
    state.isBulkSharingOpen = false;
  },

  openChangeAuthor: (state: IQuestionsListModalsState) => {
    state.isBulkChangeAuthorOpen = true;
  },

  closeChangeAuthor: (state: IQuestionsListModalsState) => {
    state.isBulkChangeAuthorOpen = false;
  },
};

export const questionsListModalsSlice = createSlice({
  name: 'questionsListModalsSlice',
  initialState,
  reducers: questionsListModalsReducer,
});

export const {
  resetState,
  openCopyQuery,
  closeCopyQuery,
  openBulkSharing,
  closeBulkSharing,
  openChangeAuthor,
  closeChangeAuthor,
} = questionsListModalsSlice.actions;

export default questionsListModalsSlice.reducer;
